module.exports = __webpack_public_path__ + "static/media/modeIcon.ba0b4b30.svg";